/** Системные события (оболочка → сервис). Доменные события сервис объявляет отдельно. */
export const SYSTEM_EVENTS = {
  Init: 'init',
  NavigationFocus: 'navigation.focus',
  NavigationBlur: 'navigation.blur',
  BackPressed: 'back.pressed',
  ThemeChanged: 'theme.changed',
  LocaleChanged: 'locale.changed',
  AuthChanged: 'auth.changed',
  AppStateChanged: 'appState.changed',
  KeyboardChanged: 'keyboard.changed',
  TabBarPressed: 'tabBar.pressed',
  SsoAuthorized: 'sso.authorized'
} as const;

export type TSystemEventName =
  (typeof SYSTEM_EVENTS)[keyof typeof SYSTEM_EVENTS];

export type TColorSchemeMode = 'light' | 'dark';

export interface ISafeAreaInsets {
  top: number;
  bottom: number;
  left: number;
  right: number;
}

/**
 * Контекст, который оболочка шлёт в сервис первым событием `init` (после `bridge.ready`).
 * `theme` — непрозрачное дерево токенов дизайн-системы (сервис потребляет структурно).
 * `webProperties.initialPath` — стартовый внутренний маршрут сервиса (из splat-URL оболочки).
 */
export interface IInitContext {
  protocolVersion: number;
  miniApp: { id: string };
  platform: string;
  mode: TColorSchemeMode;
  theme: Record<string, unknown>;
  locale: string;
  insets: ISafeAreaInsets;
  featureFlags: Record<string, boolean>;
  auth: { isAuthenticated: boolean };
  webProperties?: Record<string, unknown>;
}

/** Типы payload системных событий. */
export interface ISystemEventPayloads {
  init: IInitContext;
  'navigation.focus': null;
  'navigation.blur': null;
  'back.pressed': null;
  'theme.changed': TColorSchemeMode;
  'locale.changed': { locale: string };
  'auth.changed': { isAuthenticated: boolean };
  'appState.changed': { state: string };
  'keyboard.changed': { visible: boolean; height: number };
  'tabBar.pressed': { id: string };
  'sso.authorized': {
    authorizationCode: string;
    codeVerifier: string;
    expiresInSeconds: number;
  };
}
